import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GalerieService from '../../services/GalerieService';

const initialState = {
  Galeries: [],
  GalerieId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements: 0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createGalerie = createAsyncThunk(
  'Galerie/create',
  async (data, thunkAPI) => {
    try {
      return await GalerieService.createGalerie(data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllGalerie = createAsyncThunk(
  'Galerie/getAll',
  async (_, thunkAPI) => {
    try {
      return await GalerieService.getAll();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteGalerie = createAsyncThunk(
  'Galerie/delete',
  async (id, thunkAPI) => {
    try {
      return await GalerieService.DeleteGalerie(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const GalerieSlice = createSlice({
  name: 'galeries',
  initialState,
  reducers: {
    clearGalerie: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createGalerie.pending, state => {
        state.isLoading = true;
      })
      .addCase(createGalerie.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) state.Galeries.unshift(created);
      })
      .addCase(createGalerie.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllGalerie.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllGalerie.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.Galeries = items;
        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllGalerie.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteGalerie.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteGalerie.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedId = action.payload?.data || action.payload?.id;
        state.Galeries = state.Galeries.filter(item => item.id !== deletedId);
      })
      .addCase(deleteGalerie.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { clearGalerie } = GalerieSlice.actions;
export default GalerieSlice.reducer;
